import {Component, inject, signal} from '@angular/core';
import {BsModalService, ButtonComponent, LoadingDirective, ModalComponent} from 'bs-components';
import {TranslateDirective} from '@ngx-translate/core';
import {DemoService} from '../../../core/services/demo.service';

@Component({
  selector: 'app-reset-data-modal',
  imports: [ModalComponent, TranslateDirective, ButtonComponent, LoadingDirective],
  templateUrl: './reset-data-modal.component.html',
  styleUrl: './reset-data-modal.component.scss',
})
export class ResetDataModalComponent {
  private readonly modalService = inject(BsModalService);
  private readonly demoService = inject(DemoService);


  readonly isLoading = signal(false);

  handleResetData() {
    this.isLoading.set(true);

    this.demoService.resetData()
      .subscribe(() => {
        this.isLoading.set(false);
        this.close();
      });
  }

  close() {
    this.modalService.close();
  }
}
